module.exports = __webpack_public_path__ + "media/application/images/ui/icon-search-db10172572cf3304daf3ef80ac95523a.png";